import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

@Component({
    selector: 'gtw-credits-part-iii-f8912',
    templateUrl: './credits-part-iii-f8912.component.html',
    styleUrls: ['./credits-part-iii-f8912.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CreditsPartIIIF8912Component {
  @Input() activeTab: string = '';
  @Input() currentFormHeader: any = null;
  @Input() tableHeader: any[] = [];
  @Input() outerList: any[] = [];
  @Input() formList: any[] = [];

  @Output() fieldChange = new EventEmitter<{ item: any; value: any }>();
  @Output() dateChange = new EventEmitter<{ item: any; event: Event }>();
  @Output() dateVariousChange = new EventEmitter<any>();
  @Output() checkBox8912 = new EventEmitter<{ lineKey: any; attribKey: any; attribCol: any; item: any; checked: boolean }>();

  get rows(): any[] {
    return (this.outerList || []).filter((r: any) => r.IS_FORM_DISPLAY === 'Y');
  }

  isRegularRow(row: any): boolean {
    const t = row?.ROW_TYPE;
    return t !== 'PH' && t !== 'TH4' && t !== 'TH6' && t !== 'DT4' && t !== 'DT6'
      && !(typeof t === 'string' && t.includes('DT20'));
  }

  /**
   * Mirrors the legacy template condition for the description cell, which is
   * rendered for everything except placeholder/table-header rows. DT20 rows
   * (e.g. F8912 line 20) keep their long description even though their
   * value/checkbox cell uses a different layout.
   */
  hasDescription(row: any): boolean {
    const t = row?.ROW_TYPE;
    return t !== 'PH' && t !== 'TH4' && t !== 'TH6' && t !== 'DT4' && t !== 'DT6';
  }

  getNormalCells(lineKey: any): any[] {
    return (this.formList || []).filter(
      (x: any) => x.FORM_LINE_KEY === lineKey
        && x.IS_FORM_DISPLAY === 'Y'
        && x.EDIT_TYPE !== 'checkbox'
    );
  }

  getTH4Cells(rowType: string): any[] {
    return (this.tableHeader || []).filter((x: any) => x.ROW_TYPE === rowType && x.ROW_TYPE === 'TH4');
  }

  getTH6Cells(rowType: string): any[] {
    return (this.formList || []).filter((x: any) => x.ROW_TYPE === rowType && x.ROW_TYPE === 'TH6');
  }

  getDTCells(lineKey: any): any[] {
    return (this.formList || []).filter(
      (x: any) => x.FORM_LINE_KEY === lineKey
        && x.IS_FORM_DISPLAY === 'Y'
        && x.EDIT_TYPE !== 'checkbox'
    );
  }

  getCheckboxCells(lineKey: any): any[] {
    return (this.formList || []).filter(
      (x: any) => x.FORM_LINE_KEY === lineKey
        && x.EDIT_TYPE === 'checkbox'
    );
  }

  getNonCheckboxCells(lineKey: any): any[] {
    return (this.formList || []).filter(
      (x: any) => x.FORM_LINE_KEY === lineKey
        && x.IS_FORM_DISPLAY === 'Y'
        && x.EDIT_TYPE !== 'checkbox'
    );
  }

  onTextChange(item: any, event: any): void {
    const value = event?.target?.value ?? event;
    this.fieldChange.emit({ item, value });
  }

  onDateInputChange(item: any, event: Event): void {
    this.dateChange.emit({ item, event });
  }

  onDateVariousChange(item: any): void {
    this.dateVariousChange.emit(item);
  }

  onCheckbox8912(item: any, event: any): void {
    const checked = !!event?.target?.checked;
    item.ATTRIB_VALUE = checked ? 'true' : 'false';
    this.checkBox8912.emit({
      lineKey: item.FORM_LINE_KEY,
      attribKey: item.LINE_ATTRIB_KEY,
      attribCol: item.ATTRIB_COL,
      item,
      checked
    });
  }

  toDateInputFormat(value: string): string {
    if (!value) return '';
    const parts = String(value).split('/');
    if (parts.length !== 3) return value;
    return `${parts[2]}-${parts[0].padStart(2, '0')}-${parts[1].padStart(2, '0')}`;
  }

  trackByLineAttribKey(_: number, row: any): any {
    return row?.LINE_ATTRIB_KEY ?? row?.FORM_LINE_KEY ?? _;
  }

  isDT20(row: any): boolean {
    return typeof row?.ROW_TYPE === 'string' && row.ROW_TYPE.includes('DT20');
  }
}
